import {CompositeDecorator} from "draft-js";
import {codeTagStrategy} from "../utils";
import {CodeTag} from "../components/code-tag";

export const compositeDecorator = new CompositeDecorator([
    {
        strategy: codeTagStrategy,
        component: CodeTag,
    }
]);